import angular from 'angular';
import { ShareEmailService } from './share-email.service';
import { shareEmailInitializer } from './share-email.directive';
import captchaService from '../captcha/captcha.module'
const MODULE_NAME = 'shareEmail';
export default angular
	.module(MODULE_NAME, [captchaService])
	.service('shareEmailService', ShareEmailService)
	.directive('shareEmailInitializer', shareEmailInitializer).name;


